let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Nvfz")).then(() => parcelRequire('9ltyu'));